import React from 'react';
import {
  Heading,
  Flex,
  Box,
  FormikField,
  FormikError,
  FieldGroup,
  Option,
} from '@feast-it/pesto';

import { EVENT_TYPES } from '../../../constants/event-types';

function EventType() {
  return (
    <Flex alignItems="center" flexDirection="column">
      <Heading
        mb={9}
        textAlign="center"
        variant={['headingMedium', 'headingLarge']}
        color="blueDark"
        fontWeight={500}
      >
        What&#39;s the occasion?
      </Heading>

      <Box width="100%" maxWidth={400}>
        <FormikField
          as={FieldGroup}
          name="event.type"
          showError={false}
          submitOnChange
        >
          {EVENT_TYPES.map(field => (
            <Option
              key={`event-type-${field.value}`}
              label={field.label.replace(' and ', ' & ')}
              value={field.value}
              icon={field.icon}
              size={{ _: 'm', m: 'l' }}
              mt={{ _: 2, m: 3 }}
              testId={`event-type-option-${field.value}`}
              iconColor="blueDark"
            />
          ))}
        </FormikField>

        <FormikError
          mt={8}
          name="event.type"
          textAlign="center"
          color="redDark"
          fontFamily="body"
          fontSize="small"
          fontWeight={600}
        />
      </Box>
    </Flex>
  );
}

export default EventType;
